import React from 'react';
import styles from './scss/connectors.module.scss';
import { assets } from '../../../styles/assets/assets';

const connectorsData = [
    {
        title: 'CRM',
        description: 'Import and unify relationship data to enhance customer engagement and lifecycle management.',
        connectors: [
            // { name: 'Salesforce', icon: assets.salesforce_icon, desc: 'Connect Salesforce to sync your customer data seamlessly', status: 'Connected' },
            { name: 'HubSpot', icon: assets.hubspot_icon, desc: 'Integrate HubSpot for seamless lead and campaign management.', status: 'Connected' },
        ],
    },
    // {
    //     title: 'Online Advertising Platform',
    //     description:
    //         'Link advertising platforms to refine audience targeting and measure campaign ROI.',
    //     connectors: [
    //         { name: 'Facebook', icon: assets.facebook_icon, desc: 'Integrate Facebook to track campaign performance and engagement.', status: 'Disconnected' },
    //     ],
    // },
    // {
    //     title: 'Cloud Data Platform',
    //     description:
    //         'Centralize customer data from multiple systems for analytics, segmentation, and value modeling.',
    //     connectors: [
    //         { name: 'Twilio Segment', icon: assets.twilio_icon, desc: 'Enhance customer experience with Tidio integration for faster, personalized conversations.', status: 'Connected' },
    //         { name: 'AWS S3', icon: assets.aws_icon, status: 'Not yet Connected', desc: 'Leverage AWS to boost performance and also reliability.' },
    //         { name: 'Redshift', icon: assets.redshift_icon, status: 'Connected', desc: 'Connect to Redshift and unlock deeper business insights.' },
    //         { name: 'BigQuery', icon: assets.bigquery_icon, status: 'Connected', desc: 'Connect BigQuery to analyze massive datasets in seconds' },
    //         { name: 'Snowflake', icon: assets.snowflake_icon, status: 'Connected', desc: 'Connect the Snowflake for secure and scalable analytics.' },
    //     ],
    // },
    // {
    //     title: 'Commerce Platform',
    //     description:
    //         'Connect commerce platforms to track purchase behavior and deliver personalized offers.',
    //     connectors: [
    //         { name: 'Shopify', icon: assets.shopify_icon, desc: 'Sync Shopify to streamline your eCommerce campaigns.', status: 'Connected' },
    //         { name: 'Magento', icon: assets.magento_icon, desc: 'Sync Magento for a connected commerce experience.', status: 'Connected' },
    //     ],
    // },
];

const Connectors = () => {
    return (
        <div className={styles.connectormain}>
            {connectorsData.map((section, sectionIndex) => (
                <div key={sectionIndex} className={styles.connectorblock}>
                    <div className={styles.connectorblockheader}>
                        <div className={styles.connectorblocktitle}>{section.title}</div>
                        <div className={styles.connectorblockdesc}>{section.description}</div>
                    </div>

                    <div className={styles.connectorblockinner}>
                        {section.connectors.map((connector, connectorIndex) => (
                            <div key={connectorIndex} className={styles.connectorblockinnerbox}>
                                <div className={styles.top}>
                                    <div className={styles.left}>
                                        <img src={connector.icon} alt={`${connector.name}_icon`} />
                                    </div>
                                    <div className={styles.right}>
                                        <div className={`${styles.btns} ${connector.status === 'Connected' ? styles.connected : connector.status === 'Disconnected' ? styles.disconnected : styles.notConnected}`}>{connector.status}</div>
                                    </div>
                                </div>
                                <div className={styles.connectorblockheader}>
                                    <div className={styles.connectorblocktitle}>{connector.name}</div>
                                    <div className={styles.connectorblockdesc}>{connector.desc}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Connectors;
